import { useTrackImpressionEventByIntersection } from "@product/scmp-sdk";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { SeriesWidgetEvents } from "~/components/tracking/google-analytics/types";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";
import type { RecirculationWidgetImpressionEvent } from "~/components/tracking/google-analytics-4/types";

export const useTracking = () => {
  // cSpell:ignore Recriculation
  const impressionEvent = (): SeriesWidgetEvents => ({
    action: "Series Recirculation Widget/LHS/Impression",
    category: "Series Recriculation Widget",
    label: "",
  });

  const ga4ImpressionEvent = (): RecirculationWidgetImpressionEvent => ({
    action: "imp",
    category: "recirculation",
    customized_parameters: {
      page_type: "article",
      widget_name: "series_recirculation",
    },
    subcategory: "widget",
  });

  const { captureTrackImpressionEventTargetElement } = useTrackImpressionEventByIntersection<
    SeriesWidgetEvents,
    RecirculationWidgetImpressionEvent
  >({
    ga4TrackingHandler: sendGA4Tracking,
    gaTrackingHandler: sendGATracking,
    getEvent: impressionEvent,
    getGa4Event: ga4ImpressionEvent,
    options: {
      intersectionThreshold: [0.1],
      isSendGA4Tracking: true,
      isSendGATracking: true,
      shouldSendOnce: true,
      shouldThrottle: true,
    },
  });

  const trackClick = (entityId?: string, url?: string) => {
    sendGATracking({
      action: "Series Recirculation Widget/LHS/Click",
      category: "Series Recriculation Widget",
      label: window.location.href,
    });

    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        article_id: entityId,
        destination_url: url,
        page_type: "article",
        widget_name: "series_recirculation",
      },
      subcategory: "widget",
    });
  };

  return {
    captureTrackImpressionEventTargetElement,
    trackClick,
  };
};
